<template>
  <div>
    <vue-page-transition name="fade">
      <div v-if="showNav" class="nav-overlay">
        <div class="container">
          <nav class="navbar navbar-light px-0 py-4">
            <router-link class="navbar-brand" :to="{ name: 'home' }">
              <img src="/static/images/icons/resolute_light.svg" width="30" height="30" alt="" @click="onMenuClick">
            </router-link>
            <button @click="showNav = !showNav" class="navbar-toggler no-border px-0" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
              <img src="/static/images/icons/close_light.svg" width="24" height="24" alt="">
            </button>
          </nav>
        </div>
        <div class="container h-75 mt-5">
          <div class="d-flex justify-content-between flex-column h-100">
            <div>
              <router-link :to="{ name: 'home' }">
                <img src="/static/images/logo_white.svg" width="167" height="50" alt="">
              </router-link>
              <p class="title text-white">Where digital comes to life</p>
            </div>
            <div v-if="!isLoggedIn" @click="close">
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'about' }">About Us</router-link>
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'services' }">What We Do</router-link>
              <router-link :to="{ name: 'request-proposal' }" class="text-white h1 d-block mb-4">New Project</router-link>
              <!-- <router-link class="text-white h1 d-block mb-4" :to="{ name: 'register' }">Join</router-link> -->
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'contact' }">Contact us</router-link>
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'login' }">Sign in</router-link>
            </div>
            <div v-else>
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'dashboard-projects' }">My Projects</router-link>
              <!-- <router-link class="text-white h1 d-block mb-4" :to="{ name: 'dashboard-referrals' }">Referrals</router-link> -->
              <!-- <router-link class="text-white h1 d-block mb-4" :to="{ name: 'profile' }">My Profile</router-link> -->
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'request-proposal' }">New Project</router-link>
              <router-link class="text-white h1 d-block mb-4" :to="{ name: 'contact' }">Contact us</router-link>
              <!-- <router-link class="text-white h1 d-block mb-4" :to="{ name: 'refer' }">Refer</router-link> -->
              <a href="#" class="text-white h1 d-block mb-4" @click.prevent="logout">Log out</a>
            </div>
            <p class="smaller lh15 mb-0 text-white">Made on Earth with passion and purpose.<br>
              &copy; 2023 - 2048. All rights reserved</p>
          </div>
        </div>
      </div>
    </vue-page-transition>
    <vue-page-transition name="fade">
      <div v-if="!showNav">
        <div class="fixed-top">
          <div class="container">
            <div class="collapse" id="navbarToggleExternalContent">
              <div class="bg-dark p-4">
                <h5 class="text-white h4"></h5>
                <span class="text-muted"></span>
              </div>
            </div>
            <nav class="navbar navbar-light bg-nav px-0 py-4">
              <router-link class="navbar-brand" :to="{ name: 'home' }">
                <img src="/static/images/icons/resolute.svg" width="30" height="30" alt="" @click="onMenuClick">
              </router-link>
              <div class="flex-grow-1 d-flex justify-content-start">
                <router-link class="btn btn-sm btn-nav btn-outline-primary" :to="{ name: 'dashboard' }">
                  Dashboard
                </router-link>
              </div>
              <button @click="showNav = !showNav" class="navbar-toggler no-border px-0" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
                <img src="/static/images/icons/menu.svg" width="24" height="24" alt="">
              </button>
            </nav>
          </div>
        </div>
      </div>
    </vue-page-transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'app-header',
  data () {
    return {
      showNav: false
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn
    })
  },
  methods: {
    onMenuClick () {
      if (this.$route.path === '/') {
        this.showNav = !this.showNav
      }
    },
    close () {
      this.showNav = false
    },
    logout () {
      this.$store.dispatch('LOGOUT')
      this.$router.push('/')
    }
  },
  watch: {
    '$route' () {
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>
